import React from "react";
import { getTierConfig } from "shared/config/adaptiveLearningConfig";

/**
 * TierBadge Component
 * Displays a tier badge with icon, name, and optional tooltip
 */
const TierBadge = ({ tier, size = "md", showLabel = true, className = "" }) => {
  const config = getTierConfig(tier);

  const sizeClasses = {
    sm: "text-sm px-2 py-1",
    md: "text-base px-3 py-2",
    lg: "text-lg px-4 py-3",
    xl: "text-xl px-5 py-4",
  };

  const iconSizes = {
    sm: "text-base",
    md: "text-lg",
    lg: "text-2xl",
    xl: "text-3xl",
  };

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full font-bold transition-all duration-300 ${sizeClasses[size]} ${className}`}
      style={{
        backgroundColor: config.backgroundColor,
        color: config.color,
        border: `2px solid ${config.borderColor}`,
      }}
      title={`${config.name} - ${config.description} (${config.range})`}
    >
      <span className={iconSizes[size]}>{config.icon}</span>
      {showLabel && <span>{config.name}</span>}
    </div>
  );
};

/**
 * TierBadgeLarge Component
 * Large tier badge for results page with animation
 */
export const TierBadgeLarge = ({
  tier,
  animate = false,
  className = "",
}) => {
  const config = getTierConfig(tier);

  return (
    <div
      className={`flex flex-col items-center justify-center p-8 rounded-3xl shadow-lg ${
        animate ? "animate-bounce-once" : ""
      } ${className}`}
      style={{
        background: `linear-gradient(135deg, ${config.gradientFrom} 0%, ${config.gradientTo} 100%)`,
        border: `3px solid ${config.borderColor}`,
      }}
    >
      <div
        className="text-8xl mb-4 transition-transform duration-300 hover:scale-110"
        style={{ filter: "drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))" }}
      >
        {config.icon}
      </div>
      <h2
        className="text-4xl font-extrabold mb-2"
        style={{ color: config.color }}
      >
        {config.name}
      </h2>
      <p className="text-gray-600 dark:text-gray-400 text-center font-medium">
        {config.description}
      </p>
      <p className="text-sm text-gray-500 dark:text-gray-500 mt-2">
        {config.range}
      </p>
    </div>
  );
};

export default TierBadge;


